module.exports = __webpack_public_path__ + "static/media/top_banner_pc_04.42048670.webp";